// src/component/WalletModal.js
import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import config from "../../config/config";
import { RxCross2 } from "react-icons/rx";

const WalletModal = ({
  show,
  handleClose,
  handleWalletWithdrawl,
  handleReferralWithdrawlAction,
  handleVestingWithdrawlAction,
  handleNFTCoinWallet,
  handleStakingAction,
  wallethistorydata,
  userData,
}) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(`${config.baseUrl}Migration`);
  };
  const handleBusinessWalletTransferAction = () => {
    navigate(`${config.baseUrl}businesswallettransfer`, {
      state: { id: 6 },
    });
  };

  const handleCreditTransferAction = (id) => {
    navigate(`${config.baseUrl}CreditTransfer`, {
      state: { id: id },
    });
  };

  return (
    <Modal
      show={show}
      className="wallet-modal"
      size="lg"
      onHide={handleClose}
      centered
    >
      <button
        onClick={handleClose}
        style={{
          background: "transparent",
          border: "none",
          fontSize: "20px",
          fontWeight: "bold",
          color: "#000", // black color
          cursor: "pointer",
          lineHeight: "1",
        }}
      >
        <RxCross2 size={18} />
      </button>
      <Modal.Body className="d-flex flex-column align-items-center">
        <div className="wallet-main">
          <div className="wallet-header py-2 px-3"> <span>Select Wallet</span>
            <button
              onClick={handleClose}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "20px",
                float: 'right',
                fontWeight: "bold",
                color: "black", // black color
                cursor: "pointer",
                lineHeight: "1",
              }}
            >
              <RxCross2 size={20} />

            </button></div>

          <div className="px-3 py-3">
            {/* ======NFT coin wallet================ */}
            <div className="wallet-card gap-2 mt-2 align-items-center px-3 py-3 position-relative overflow-hidden d-block">
              <div>
                <div className="d-flex d-sm-flex justify-content-between align-items-center mb-2">
                  <p
                    className="text-white mb-1 wallet-modal-data1"
                    style={{ fontWeight: 700 }}
                  >
                    <span className="me-1">
                      <img
                        src="assets/images/walletback1.svg"
                        style={{
                          position: "absolute",
                          right: 0,
                          opacity: 0.5,
                          top: 0,
                          zIndex: 0,
                        }}
                        alt=""
                      />
                      <img
                        src="assets/images/walletback2.svg"
                        style={{
                          position: "absolute",
                          left: 0,
                          top: 0,
                          opacity: 0.5,
                          zIndex: 0,
                        }}
                        alt=""
                      />
                      <img
                        src="assets/images/wallet02.png"
                        alt=""
                        style={{ width: 35, height: 35, zIndex: 0 }}
                      />
                    </span>
                    Step Legacy Wallet
                  </p>
                  <p
                    className="text-white mb-0 wallet-modal-data2 text-end"
                    style={{ fontWeight: 700 }}
                  >
                    <img src="assets/images/" alt="" />
                    {wallethistorydata.nftcoin_balance}{" "}
                    <span style={{ fontSize: 9 }}>ANANT</span>
                  </p>
                </div>

                <Row className="justify-content-between">
                  <Col xl={4} lg={4} className="mb-2 mb-md-0">
                    <button
                      onClick={handleNFTCoinWallet}
                      className="text-white px-3 px-sm-5 btn btn-main2 maxamount2 rounded-2 mb-2 mb-md-0 w-100"
                      style={{ fontSize: 12 }}
                      type="button"
                    >
                      <img
                        src="assets/images/icon/withdraw.png"
                        style={{ width: 20, height: 20 }}
                        className="me-2"
                      />{" "}
                      Withdraw
                    </button>
                  </Col>
                  <Col
                    xl={4}
                    lg={4}
                    style={{ marginLeft: "2px", zIndex: 1 }}
                    className="mb-2 mb-md-0"
                  >
                    <button
                      onClick={() => handleCreditTransferAction(7)}
                      className="text-white px-3 px-sm-5 btn btn-main2 maxamount2 rounded-2 mb-2 mb-md-0 w-100"
                      style={{ fontSize: 12 }}
                      type="button"
                    >
                      <img
                        src="assets/images/icon/withdraw.png"
                        style={{ width: 20, height: 20 }}
                        className="me-2"
                      />{" "}
                      Send
                    </button>
                  </Col>

                  <Col xl={4} lg={4} className="mb-2 mb-md-0"></Col>
                </Row>

                {/* </div> */}
              </div>
            </div>
            <div className="wallet-card gap-2 mt-2 align-items-center px-3 py-3 position-relative overflow-hidden d-block">
              <div>
                <div className="d-flex d-sm-flex justify-content-between align-items-center mb-2">
                  <p
                    className="text-white mb-1 wallet-modal-data1"
                    style={{ fontWeight: 700 }}
                  >
                    <span className="me-1">
                      <img
                        src="assets/images/walletback1.svg"
                        style={{
                          position: "absolute",
                          right: 0,
                          opacity: 0.5,
                          top: 0,
                          zIndex: 0,
                        }}
                        alt=""
                      />
                      <img
                        src="assets/images/walletback2.svg"
                        style={{
                          position: "absolute",
                          left: 0,
                          top: 0,

                          opacity: 0.5,
                          zIndex: 0,
                        }}
                        alt=""
                      />
                      <img
                        src="assets/images/wallet02.png"
                        alt=""
                        style={{ width: 35, height: 35 }}
                      />
                    </span>
                    NFT Box Wallet
                  </p>
                  <p
                    className="text-white mb-0 wallet-modal-data2 text-end"
                    style={{ fontWeight: 700 }}
                  >
                    <img src="assets/images/" alt="" />
                    {wallethistorydata.stepcoin_balance}{" "}
                    <span style={{ fontSize: 9 }}>ANANT</span>
                  </p>
                </div>

                <Row className="justify-content-between">
                  <Col xl={4} lg={4} className="mb-2 mb-md-0">
                    <button
                      onClick={handleWalletWithdrawl}
                      className="text-white px-3 px-sm-5 btn btn-main2 maxamount2 rounded-2 mb-2 mb-md-0 w-100"
                      style={{ fontSize: 12, zIndex: 1 }}
                      type="button"
                    >
                      <img
                        src="assets/images/icon/withdraw.png"
                        style={{ width: 20, height: 20 }}
                        className="me-2"
                      />{" "}
                      Withdraw
                    </button>
                  </Col>

                  <Col xl={4} lg={4} className="mb-2 mb-md-0"></Col>
                  <Col
                    xl={4}
                    lg={4}
                    className="mb-2 mb-md-0"
                    style={{ zIndex: 1 }}
                  >
                    <button
                      onClick={() => handleCreditTransferAction(5)}
                      className="text-white px-3 px-sm-5 btn btn-main2 maxamount2 rounded-2 mb-2 mb-md-0 w-100"
                      style={{ fontSize: 12, zIndex: 1 }}
                      type="button"
                    >
                      <img
                        src="assets/images/icon/withdraw.png"
                        style={{ width: 20, height: 20 }}
                        className="me-2"
                      />{" "}
                      Send
                    </button>
                  </Col>

                  <Col xl={4} lg={4} className="mb-2 mb-md-0"></Col>
                </Row>

                {/* </div> */}
              </div>
            </div>

            <div className="wallet-card mt-3 gap-2 align-items-center px-3 py-3 position-relative overflow-hidden d-block">
              <div>
                <div className="d-flex d-sm-flex justify-content-between align-items-center mb-2">
                  <p
                    className="text-white mb-1 wallet-modal-data1"
                    style={{ fontWeight: 700 }}
                  >
                    <span className="me-1">
                      <img
                        src="assets/images/walletback1.svg"
                        style={{
                          position: "absolute",
                          right: 0,
                          opacity: 0.5,
                          top: 0,
                          zIndex: 0,
                        }}
                        alt=""
                      />
                      <img
                        src="assets/images/walletback2.svg"
                        style={{
                          position: "absolute",
                          left: 0,
                          top: 0,
                          opacity: 0.5,
                          zIndex: 0,
                        }}
                        alt=""
                      />
                      <img
                        src="assets/images/walletnew.png"
                        alt=""
                        style={{ width: 35, height: 35 }}
                      />
                    </span>
                    Business Coin Wallet
                  </p>
                  <p
                    className="text-white mb-0 wallet-modal-data1 text-end"
                    style={{ fontWeight: 700 }}
                  >
                    {wallethistorydata.businesscoin_balance}{" "}
                    <span style={{ fontSize: 9 }}>ANANT</span>
                  </p>
                </div>
                <Row className="justify-content-between gy-3">
                  <Col xl={4} lg={4} className="">
                    <button
                      onClick={handleReferralWithdrawlAction}
                      className="text-white px-3 px-sm-5 btn btn-main2 maxamount2 rounded-2 w-100"
                      style={{ fontSize: 12 }}
                      type="button"
                    >
                      <img src="assets/images/icon/withdraw.png" style={{ width: 20, height: 20 }}
                        className="me-2"
                      /> Withdraw
                    </button>
                  </Col>
                  {/* <Col xl={4} lg={4} style={{ zIndex: 1 }}>
                    <button
                      onClick={handleBusinessWalletTransferAction}
                      className=" text-white px-3  px-sm-5 btn btn-main2 maxamount2 rounded-2 w-100"
                      style={{ fontSize: 12 }}
                      type="button"
                    >
                      Transfer
                    </button>
                  </Col> */}
                  <Col
                    xl={4}
                    lg={4}
                    className="mb-2 mb-md-0"
                    style={{ zIndex: 1 }}
                  >
                    {/* <button
                      onClick={() => handleCreditTransferAction(6)}
                      className="text-white px-3 px-sm-5 btn btn-main2 maxamount2 rounded-2 w-100"
                      style={{ fontSize: 12, zIndex: 1 }}
                      type="button"
                    >
                      <img
                        src="assets/images/icon/withdraw.png"
                        style={{ width: 20, height: 20 }}
                        className="me-2"
                      />{" "}
                      Send
                    </button> */}
                  </Col>
                </Row>
                {/* </div> */}
              </div>
            </div>
            <div className="wallet-card mt-3 mb-2 gap-2 align-items-center px-3 py-3 position-relative overflow-hidden d-block">
              <div>
                <div className="d-flex d-sm-flex justify-content-between align-items-center mb-2">
                  <p
                    className="text-white mb-1 wallet-modal-data1"
                    style={{ fontWeight: 700 }}
                  >
                    <span className="me-1">
                      <img
                        src="assets/images/walletback1.svg"
                        style={{
                          position: "absolute",
                          right: 0,
                          opacity: 0.5,
                          top: 0,
                          zIndex: 0,
                        }}
                        alt=""
                      />
                      <img
                        src="assets/images/walletback2.svg"
                        style={{
                          position: "absolute",
                          left: 0,
                          top: 0,
                          opacity: 0.5,
                          zIndex: 0,
                        }}
                        alt=""
                      />
                      <img
                        src="assets/images/walletnew.png"
                        alt=""
                        style={{ width: 35, height: 35 }}
                      />
                    </span>
                    Vesting Wallet
                  </p>
                  <p
                    className="text-white mb-0 wallet-modal-data2 text-end"
                    style={{ fontWeight: 700 }}
                  >
                    {wallethistorydata.vesting_wallet_balance}{" "}
                    <span style={{ fontSize: 9 }}>ANANT</span>
                  </p>
                </div>

                {/* <div
                  className="d-flex justify-content-between mb-1"
                  style={{ position: "relative" }}
                > */}
                <Row className="justify-content-between">
                  <Col xl={4} lg={4} className="mb-2 mb-md-0">
                    <button
                      onClick={handleStakingAction}
                      className="text-white px-3 px-sm-5 btn btn-main2 maxamount2 rounded-2 w-100"
                      style={{ fontSize: 12, zIndex: 1 }}
                      type="button"
                    >
                      Staking History
                    </button>
                  </Col>

                  <Col xl={4} lg={4} style={{ zIndex: 1 }}>
                    <button
                      onClick={handleVestingWithdrawlAction}
                      className=" pull-right  text-white px-3 px-sm-5 btn btn-main2 maxamount2 rounded-2 w-100"
                      style={{ fontSize: 12, zIndex: 1 }}
                      type="button"
                    >
                      View Details
                    </button>
                  </Col>
                </Row>
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default WalletModal;
